window.appLoaded.then(() => {
    $(document).ready(function () {
        /** ADDRESS-ACCOUNT **/
        if (strPage == 'address-account') {
            // Form validate
            FormValidateAddressAccount($('form#frmAddressAccount'));
        }

        /** ADDRESS-BOOK **/
        else if (strPage == 'address-book') {
            // When clicking on button 'Add new address' => slide open the form below
            $('#addaddress').click(function () {
                // $(this).parent().hide();
                $('form#frmAddAddress').removeClass('hidden');

                $('div.alert.address-added').hide();
                return false;
            });

            // Remove address
            $('button[id*="deleteaddress"]').click(function () {
                var objThis = $(this);
                var arrId = $(this).attr('id').split('-');
                var intId = arrId[1];

                $.post(strAjaxPath + 'customerzone/delete-address.php', 'addresssalesorderno=' + intId, function (data) {
                    // Hide address
                    objThis.closest('form').hide();
                    // Hide checkbox next to it
                    // objThis.parent().parent().parent().next().next().hide();
                    // Show notification when address is removed
                    //objThis.parent().parent().parent().children("div.alert").slideDown('fast');
                });
                return false;
            });

            // Update address
            $('button[id*="updateaddress"]').click(function () {
                // Make address invisible
                var objLink = $(this);
                var objParent = objLink.parents('form');
                objParent.find('address').addClass('hidden');
                objParent.find('.edit-address-form').removeClass('hidden');
                objLink.parent().parent().toggleClass('hidden');
                return false;
            });

            $('.cancel').click(function () {
                var objLink = $(this);
                var objParent = objLink.parents('form');
                objParent.find('.hidden').removeClass('hidden');
                objParent.find('.edit-address-form').addClass('hidden');
                return false;
            });

            // Indicate address as standard delivery address
            $('.defaultaddress').on('click', function () {
                var objThis = $(this);

                // Check out other radiobuttons
                $('.defaultaddress').each(function () {
                    if (objThis.val() != $(this).val()) {
                        $(this).prop('checked', false);
                    }
                });

                // Update default delivery address
                $.post(strAjaxPath + 'customerzone/set-defaultaddress.php', 'addresssalesorderno=' + objThis.val(), function (data) {

                }, 'json');
            });

            // Form validate 'Add new adress' (in address book)
            FormValidateAddAddress($('form#frmAddAddress'));

            // Form validate 'Edit adress' (in address book) (per address)
            $.each(arrSalesorderAddresses, function (i, val) {
                FormValidateUpdateAddress($('form#frmUpdateAddress' + val));
            });
        }

        /** ADDRESS-DATA **/
        else if (strPage == 'address-data') {
            // Form validate
            FormValidateAddressData($('form#frmAddressData'));
        }

        /** ADDRESS GIFTCARDS **/
        else if (strPage == 'address-giftcards') {

            // When clicking enter in giftcard-code field
            $('#txtGiftcardCode').keypress(function (e) {
                if (e.which == 13) {
                    // Click on activate button
                    $('#frmActivate input[type="button"]').click();
                    return false;
                }
            });

            // Click on 'Activate' button
            $('#frmActivate input[type="button"]').click(function (e) {
                $('form#frmActivate').find('.alert-danger').remove();

                if ($('#txtGiftcardCode').val()) {
                    // Remove previous errors
                    $('#txtGiftcardCode').removeClass('is-invalid');

                    // Validate
                    var strParams = 'intAddressNo=' + intAddressNo + '&strGiftCardCode=' + $('input#txtGiftcardCode').val();
                    $.post(strAjaxPath + 'customerzone/address-giftcard.php', strParams, function (data) {
                        if (data.value == 0) {
                            // Show error
                            $('form#frmActivate').append('<div class=\'alert alert-danger mt-2\'>' + data.message + '</div>');
                        } else if (data.value == 1) {
                            // Correct code => reload page
                            document.location.reload();
                        }
                    }, 'json');
                } else {
                    $('form#frmActivate').append('<div class=\'alert alert-danger mt-2\'>' + strLabelRequired + '</div>');
                    $('#txtGiftcardCode').addClass('is-invalid');
                }

                return false;
            });
        } else if (strPage == 'orders') {
            // Accordion
            $('button[data-action="load-order"]').on('click', function (e) {
                const salesOrderNo = $(this).attr('data-target');
                if (!salesOrderNo) {
                    return false;
                }

                // check if data is loaded
                const orderDetails = document.getElementById(`salesOrderDetails-${salesOrderNo}`);
                if (orderDetails.hasAttribute('data-loaded')) {
                    return false;
                }

                // load data
                $.get(`${strAjaxPath}order/get-order-details.php?intSalesOrderNo=${salesOrderNo}`, function (data) {
                    if (data.status !== 200) {
                        return false;
                    }
                    orderDetails.innerHTML = data.view;
                    $(orderDetails).show();
                    orderDetails.setAttribute('data-loaded', 'true');
                });
                return false;
            });
        }

        // Show left menu mobile
        $('.toggle-cz-menu').click(function () {
            $('body').toggleClass('cz-menu-open');
        });

        // Show left menu mobile
        $('a.showfilters').click(function () {
            $('body').removeClass('push-menu');
            $('body').toggleClass('push-filter');
            $(this).toggleClass('active');
        });

        $('a.hidefilters').click(function () {
            $('body').removeClass('push-filter');
            $('a.showfilters').removeClass('active');
        });
    });
});
